export const RankIcon = ({ color = "#FFB743" }) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_20214_629343)">
                <path
                    d="M7.31153 14.7384C8.90469 12.3213 10.4978 9.90435 12.091 7.48731C12.4441 6.95148 13.2695 7.11487 13.3918 7.74479C13.7187 9.4276 14.0456 11.1103 14.3726 12.7931C14.4802 13.3472 15.0312 13.697 15.5784 13.5588L21.5652 12.0468C22.1978 11.887 22.7894 12.4222 22.6936 13.0677L21.7866 19.1755C21.7036 19.7338 22.1068 20.247 22.6688 20.2989C24.3758 20.4562 26.0827 20.6136 27.7898 20.7709C28.4288 20.8298 28.6737 21.6348 28.1758 22.0396C25.9298 23.8661 23.6839 25.6924 21.4379 27.5188L7.31153 14.7384Z"
                    fill={color}
                />
                <path
                    d="M17.5064 30.3841L4.85304 18.9363C4.44629 18.5683 4.41487 17.9403 4.78287 17.5335L6.24658 15.9156L20.3729 28.6961L18.9092 30.314C18.5412 30.7207 17.9131 30.7521 17.5064 30.3841Z"
                    fill={color}
                />
                <circle
                    cx="23.6468"
                    cy="10.913"
                    r="1.12444"
                    transform="rotate(42.1364 23.6468 10.913)"
                    fill={color}
                />
                <circle
                    cx="29.9417"
                    cy="20.8165"
                    r="1.12444"
                    transform="rotate(42.1364 29.9417 20.8165)"
                    fill={color}
                />
                <circle
                    cx="13.1644"
                    cy="5.6379"
                    r="1.12444"
                    transform="rotate(42.1364 13.1644 5.6379)"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_20214_629343">
                    <rect
                        width="24.9647"
                        height="24.9647"
                        fill="white"
                        transform="translate(16.749) rotate(42.1364)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
